import { render } from "./list2.vue?vue&type=template&id=60a281c6&scoped=true"
import script from "./list2.vue?vue&type=script&lang=js"
export * from "./list2.vue?vue&type=script&lang=js"

import "./list2.vue?vue&type=style&index=0&id=60a281c6&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a281c6"]])

export default __exports__